import type { RouteObject } from 'react-router';
import { RequirePlatformAdmin } from '@/features/auth/guards';
import { PlatformAccountPage } from './account-page';
import { PlatformAuditPage } from './audit-page';
import { BillingPage } from './billing-page';
import { MetricsPage } from './metrics-page';
import { OrgDetailPage } from './org-detail-page';
import { OrgsPage } from './orgs-page';
import { OverviewPage } from './overview-page';
import { PlansPage } from './plans-page';
import { PlatformLayout } from './platform-layout';
import { PlatformSettingsPage } from './settings-page';
import { ServicesPage } from './services-page';
import { SubscriptionsPage } from './subscriptions-page';
import { SupportPage } from './support-page';
import { UsagePage } from './usage-page';
import { UsersPage } from './users-page';

export const platformRoutes: RouteObject[] = [
  {
    path: 'plataforma',
    element: (
      <RequirePlatformAdmin>
        <PlatformLayout />
      </RequirePlatformAdmin>
    ),
    children: [
      { index: true, element: <OverviewPage /> },
      { path: 'organizacoes', element: <OrgsPage /> },
      { path: 'organizacoes/:id', element: <OrgDetailPage /> },
      { path: 'usuarios', element: <UsersPage /> },
      { path: 'planos', element: <PlansPage /> },
      { path: 'assinaturas', element: <SubscriptionsPage /> },
      { path: 'cobranca', element: <BillingPage /> },
      { path: 'uso', element: <UsagePage /> },
      { path: 'suporte', element: <SupportPage /> },
      { path: 'metricas', element: <MetricsPage /> },
      { path: 'auditoria', element: <PlatformAuditPage /> },
      { path: 'conta', element: <PlatformAccountPage /> },
      { path: 'servicos', element: <ServicesPage /> },
      { path: 'configuracoes', element: <PlatformSettingsPage /> },
    ],
  },
];
